module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eds9b"))).then(() => parcelRequire('1iHdE'));